import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector'; // Import LanguageDetector

import translationEN from './i18n/en.json';
import translationFA from './i18n/fa.json';

// the translations
const resources = {
  en: {
    translation: translationEN
  },
  fa: {
    translation: translationFA
  }
};

i18n
  .use(LanguageDetector) // Add LanguageDetector
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    // lng: 'fa', // Explicitly set default language to Persian
    fallbackLng: 'fa', // Fallback language if detection fails

    keySeparator: '.', // we use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;